<div class="page-header">
  <app-prev-next-button (click)="toDashboard()" direction="left" icon="estate"></app-prev-next-button>
  <h1>Mapa</h1>
</div>
<div *ngIf="this.fullLoaderService.isOpen$ | async">
  <app-full-page-loader></app-full-page-loader>
</div>
<div class="page-content" >
  <div class="left-side">
    <app-map-input-filter (filterApplied)="applyFilter($event)" (filterCleared)="clearFilter($event)"></app-map-input-filter>
    <app-warehouse-aggregation [map]="map"></app-warehouse-aggregation>
    <app-ground-types-aggregation [map]="map" [selectedGroupId]="lastHighlightedGroupId" (onGroupClick)="groupClicked($event)"></app-ground-types-aggregation>
  </div>
  <div class="right-side" [class.blurred]="(fullLoaderService.isOpen$ | async)">
    <app-side-color-card color="primary-1">
      <app-warehouse-map-task-position-view id="zz"
                                            content
                                            #mapComponent
                                            (mapLoaded)="mapLoaded()"
                                            (toggleTipEvent)="openTip = $event"
                                            (triggerLoader)="showLoader($event)"
                                            [openTip]="openTip"
                                            [map]="map"
                                            [selectedPositionIds]="selectedPositionIds">
      </app-warehouse-map-task-position-view>
    </app-side-color-card>
  </div>
</div>

<ng-template #notification>
  <app-notification [data]="notificationData" icon="times-circle"></app-notification>
</ng-template>
